export const dailyTradesReportLocation = "/reports/sec/monthlyreports"